import { render, staticRenderFns } from "./HumanCapitalAgeAverageReport.vue?vue&type=template&id=fc844c48&scoped=true&"
import script from "./HumanCapitalAgeAverageReport.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalAgeAverageReport.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalAgeAverageReport.vue?vue&type=style&index=0&id=fc844c48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc844c48",
  null
  
)

export default component.exports